// Real photos from Romain's portfolio — stored locally in /public/photos/
// 84 source photos extracted from user-provided PDFs + Romain's portrait (romain.jpg)
// Selection curated by category quality for each section.

const local = (n) => `/photos/photo_${String(n).padStart(2, "0")}.jpg`;

// HERO — aerial lava flow landscape (mystical, cinematic wide shot)
export const HERO_IMAGE = local(7);

// Sony macro fallback (lens itself is pure SVG; we don't render this)
export const CAMERA_MACRO = local(8);

// "Le photographe" — Romain Bruneau portrait (with telephoto lens, red vest)
export const ROMAIN_PORTRAIT = "/photos/romain.jpg";

// Featured film still — volcano erupting (dramatic action moment)
export const FEATURED_FILM_STILL = local(8);

// PORTFOLIO — broad selection across all disciplines.
// Each entry can carry a short reflective caption used by the lightbox.
export const PORTFOLIO = [
  // Paysages — mountains, snow, volcanic
  { id: "p1",  src: local(42), cat: "paysage",  title: "Vallée enneigée",         caption: "Le silence se mesure en altitude." },
  { id: "p2",  src: local(33), cat: "paysage",  title: "Crêtes acérées",          caption: "La pierre, à force de patience, devient lumière." },
  { id: "p3",  src: local(32), cat: "paysage",  title: "Face nord",               caption: "Ce qui ne se laisse jamais conquérir, on apprend à l'écouter." },
  { id: "p4",  src: local(60), cat: "paysage",  title: "Sommet majestueux",       caption: "On n'atteint pas un sommet, on s'y laisse trouver." },
  { id: "p5",  src: local(31), cat: "paysage",  title: "Pic ensoleillé",          caption: "Une seconde de lumière vaut mille ascensions." },
  { id: "p6",  src: local(34), cat: "paysage",  title: "Crête au matin",          caption: "L'aube ne prévient jamais. Elle arrive, simplement." },
  { id: "p7",  src: local(7),  cat: "paysage",  title: "Survol du volcan",        caption: "Survoler la lave, c'est écouter la mémoire du monde avant les mots." },
  { id: "p8",  src: local(8),  cat: "paysage",  title: "Cratère en éruption",     caption: "Quand la matière devient lumière, on comprend qu'on est de passage." },
  { id: "p9",  src: local(22), cat: "paysage",  title: "Lave et fumée",           caption: "La terre respire encore, parfois fort, parfois doucement." },
  { id: "p10", src: local(43), cat: "paysage",  title: "Rivière en altitude",     caption: "Le chemin de l'eau n'est jamais droit, c'est sa façon d'être sage." },
  // Sport — kayak / canoe slalom
  { id: "p11", src: local(1),  cat: "sport",    title: "Victoire",                caption: "Lever les bras, c'est déposer mille heures invisibles." },
  { id: "p12", src: local(2),  cat: "sport",    title: "Triomphe",                caption: "Le triomphe est l'aboutissement d'une longue conversation avec soi-même." },
  { id: "p13", src: local(3),  cat: "sport",    title: "Championne",              caption: "Elle ne court pas après le titre, elle l'attend depuis longtemps." },
  { id: "p14", src: local(5),  cat: "sport",    title: "Eau vive · Pau",          caption: "L'eau ne pardonne pas, mais elle apprend à ceux qui l'écoutent." },
  { id: "p15", src: local(6),  cat: "sport",    title: "Rapides",                 caption: "Au cœur des rapides, le temps choisit son propre rythme." },
  { id: "p16", src: local(44), cat: "sport",    title: "Bassin slalom",           caption: "Chaque porte est une question, chaque passage une réponse." },
  { id: "p17", src: local(23), cat: "sport",    title: "Médaille · Paris",        caption: "L'or n'est qu'un éclat. La vraie médaille est invisible." },
  { id: "p18", src: local(85), cat: "sport",    title: "L'œil patient",           caption: "Avant l'instant décisif, il y a mille secondes de patience." },
  // Aventure — ski, surf, BMX, ultra
  { id: "p19", src: local(36), cat: "aventure", title: "Descente alpine",         caption: "Le vide n'est pas vide pour qui sait le lire." },
  { id: "p20", src: local(37), cat: "aventure", title: "Couloir vertical",        caption: "Il faut accepter la chute pour comprendre la verticalité." },
  { id: "p21", src: local(66), cat: "aventure", title: "Surf · phare",            caption: "Sous le phare, l'océan répète sa seule promesse : recommencer." },
  { id: "p22", src: local(65), cat: "aventure", title: "Vague atlantique",        caption: "L'Atlantique n'oublie rien. Il sculpte, sans cesse." },
  { id: "p23", src: local(67), cat: "aventure", title: "Pointe rocheuse",         caption: "Là où la roche rencontre l'eau, le monde devient frontière." },
  { id: "p24", src: local(4),  cat: "aventure", title: "BMX urbain",              caption: "Le béton aussi sait porter des envols." },
  { id: "p25", src: local(45), cat: "aventure", title: "Triathlon",               caption: "Trois disciplines, un seul battement de cœur." },
  { id: "p26", src: local(46), cat: "aventure", title: "Route · peloton",         caption: "Le peloton est une cathédrale qui roule." },
  { id: "p27", src: local(47), cat: "aventure", title: "Ultra-running",           caption: "Courir, c'est négocier longuement avec sa propre nuit." },
];

// CULINAIRES — food / restaurant photography
export const CULINAIRES = [
  { id: "c1", src: local(19), title: "Petit-déjeuner du dimanche" },
  { id: "c2", src: local(20), title: "Pancakes en cuisson" },
  { id: "c3", src: local(18), title: "Brunch matinal" },
  { id: "c4", src: local(26), title: "Dressage signature" },
  { id: "c5", src: local(27), title: "Dégustation gourmande" },
];

export const SERVICE_TILES = [
  {
    key: "photographie",
    label: "Photographie sportive",
    desc: "Compétitions, athlètes en action, eau vive.",
    img: local(5),
  },
  {
    key: "paysage",
    label: "Paysages & expéditions",
    desc: "Volcans, sommets enneigés, expéditions sauvages.",
    img: local(42),
  },
  {
    key: "aventure",
    label: "Sports extrêmes",
    desc: "Ski, surf, alpinisme, vol libre.",
    img: local(36),
  },
  {
    key: "culinaire",
    label: "Photographie culinaire",
    desc: "Restaurants, plats, mise en scène gastronomique.",
    img: local(19),
  },
];

export const BRAND_LOGOS = [
  "FFCK",
  "Snoolking",
  "Italian Kayak Team",
  "Polish Canoe Team",
  "Great Britain Kayak Team",
  "Decathlon",
];

// Profile portraits — athletes Romain photographed who endorse his work.
// Real photos from Romain's own collection.
export const TALENTS = [
  {
    id: "jess-fox",
    name: "Jess Fox",
    flag: "AU",
    title: "3× Championne Olympique",
    discipline: "Canoë slalom · Australie",
    sponsor: null,
    quote:
      "Romain a un œil de compétiteur. Il sait ce qu'on vit dans le bassin, ça change tout dans l'image.",
    portrait: "/photos/jess_fox.jpg",
    credit: "Photo : Romain Bruneau",
  },
  {
    id: "nicolas-gestin",
    name: "Nicolas Gestin",
    flag: "FR",
    title: "Champion Olympique · Paris 2024",
    discipline: "Canoë slalom · France",
    sponsor: "Équipe de France",
    quote:
      "Une lecture d'eau précise et une présence rare au bord de la rivière. Romain capte le moment juste.",
    portrait: "/photos/nicolas_gestin.jpg",
    credit: "Photo : Romain Bruneau",
  },
];

// Additional names Romain has photographed — editorial typographic cards with tight face-crop avatars.
export const TALENT_NAMES = [
  { name: "Bun Hay Mean",   role: "Humoriste · Scène",       portrait: "/photos/talents/bun_hay_mean.jpg" },
  { name: "Nino Arial",     role: "Artiste",                  portrait: "/photos/talents/nino_arial.jpg" },
  { name: "Soolking",       role: "Rappeur · Tournée",        portrait: "/photos/talents/soolking.jpg" },
  { name: "Soprano",        role: "Chanteur · Stade",         portrait: "/photos/talents/soprano.jpg" },
  { name: "Mustapha Salmi", role: "Athlète · 10 km",          portrait: "/photos/talents/mustapha_salmi.jpg" },
];

export const TESTIMONIALS = [
  {
    quote:
      "Romain capte l'effort comme personne. C'est un athlète qui filme, ça se voit dans chaque image.",
    name: "Direction sportive",
    org: "FFCK · Coupe du Monde Pau",
  },
  {
    quote:
      "Travailler avec un compétiteur international change radicalement le regard porté sur la discipline.",
    name: "Luuka Jones-Yaxley",
    org: "Kayakiste olympique",
  },
  {
    quote:
      "Réalisation précise, engagement physique, sens du récit. Une signature rare en production sportive.",
    name: "Direction com.",
    org: "Groupe Primalys",
  },
];

export const FAQ = [
  {
    q: "Quelles disciplines couvrez-vous ?",
    a: "Kayak slalom, eau vive, triathlon, ironman, ultra-running, surf, ski, paysages d'altitude et photographie culinaire.",
  },
  {
    q: "Comment se passe une collaboration ?",
    a: "Briefing du projet, repérages, captation en immersion, puis post-production. Livraison sous 2 à 6 semaines selon le format.",
  },
  {
    q: "Êtes-vous basé à Pau ?",
    a: "Oui, Pau et les Pyrénées-Atlantiques. Je me déplace en France, en Europe et au-delà selon les projets.",
  },
  {
    q: "Quels sont vos projets en cours ?",
    a: "Marathon des Sables (250 km dans le désert marocain), Enduroman (triathlon Londres-Paris), qualification aux Championnats du Monde Ironman, sélection équipe de France kayak U23.",
  },
  {
    q: "Quels livrables proposez-vous ?",
    a: "Photos HD, films courts, reels Instagram, films d'événement, contenus corporate, tirages d'art en édition limitée.",
  },
];

// ---- Shop ----

export const SHOP_PRODUCTS = [
  // Paysages (premium prints — landscape format)
  { id: "s1",  title: "Vallée enneigée",       img: local(42), cat: "paysage" },
  { id: "s2",  title: "Crêtes acérées",        img: local(33), cat: "paysage" },
  { id: "s3",  title: "Sommet majestueux",     img: local(60), cat: "paysage" },
  { id: "s4",  title: "Face nord",             img: local(32), cat: "paysage" },
  { id: "s5",  title: "Pic ensoleillé",        img: local(31), cat: "paysage" },
  { id: "s6",  title: "Crête au matin",        img: local(34), cat: "paysage" },
  { id: "s7",  title: "Survol du volcan",      img: local(7),  cat: "paysage" },
  { id: "s8",  title: "Cratère en éruption",   img: local(8),  cat: "paysage" },
  { id: "s9",  title: "Lave et fumée",         img: local(22), cat: "paysage" },
  { id: "s10", title: "Rivière en altitude",   img: local(43), cat: "paysage" },
  // Sport
  { id: "s11", title: "Eau vive · Pau",        img: local(5),  cat: "sport" },
  { id: "s12", title: "Médaille · Paris 2024", img: local(23), cat: "sport" },
  { id: "s13", title: "Victoire",              img: local(1),  cat: "sport" },
  { id: "s14", title: "Championne",            img: local(3),  cat: "sport" },
  { id: "s15", title: "L'œil patient",         img: local(85), cat: "sport" },
  // Aventure
  { id: "s16", title: "Descente alpine",       img: local(36), cat: "aventure" },
  { id: "s17", title: "Couloir vertical",      img: local(37), cat: "aventure" },
  { id: "s18", title: "Surf · phare",          img: local(66), cat: "aventure" },
  { id: "s19", title: "Vague atlantique",      img: local(65), cat: "aventure" },
  { id: "s20", title: "Ultra-running",         img: local(47), cat: "aventure" },
];

export const SHOP_SIZES = [
  { key: "20x30", label: "20 × 30 cm", price: 25, shipping: 5.9 },
  { key: "30x45", label: "30 × 45 cm", price: 45, shipping: 7.9 },
  { key: "40x60", label: "40 × 60 cm", price: 75, shipping: 9.9 },
  { key: "50x70", label: "50 × 70 cm", price: 110, shipping: 11.9 },
  { key: "60x90", label: "60 × 90 cm", price: 165, shipping: 14.9 },
  { key: "80x120", label: "80 × 120 cm", price: 285, shipping: 18.9 },
];

export const SHOP_PAPERS = [
  { key: "pearl", label: "Fuji Pearl", descKey: "paper.pearl.desc" },
  { key: "velvet", label: "Fuji Velvet", descKey: "paper.velvet.desc" },
];

export const FREE_SHIPPING_THRESHOLD = 150;
